import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import AnnualCalendar from "@/components/AnnualCalendar";

// Standalone page wrapper for /leads/calendar. The grid lives in the
// AnnualCalendar component and is also embedded as a tab on /leads.
export default function RetreatPlanner() {
  return (
    <div className="p-6 max-w-[1600px] mx-auto space-y-5" data-testid="retreat-planner-page">
      <div>
        <Link to="/leads" className="text-xs text-slate-500 hover:text-slate-900 flex items-center gap-1" data-testid="planner-back-leads">
          <ChevronLeft size={12} /> Back to Pipeline
        </Link>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900 mt-1">Annual Retreat Calendar</h1>
        <p className="text-sm text-slate-500 mt-0.5">Months across · days down · click to add, drag to move/resize</p>
      </div>
      <AnnualCalendar />
    </div>
  );
}
